'use client';

import {useRef} from 'react';

import {
  AppsSelectionWithoutContent,
  AppType,
  SelectionApp,
} from '@web-catalog/types';

import {
  useLogCompilationSwipe,
  useLogOnCompilationShow,
} from '@web-catalog/utils/analytics/interestingPage';

import {AppsCarousel} from './AppsCarousel';

type Props = {
  apps: SelectionApp[];
  selection: AppsSelectionWithoutContent;
  appType: AppType;
  displayedSelectionNumber: number;
  redesignRating?: boolean;
};

export const AppsCarouselFromSelection = ({
  apps,
  selection,
  appType,
  displayedSelectionNumber,
  redesignRating,
}: Props) => {
  const ref = useRef(null);
  useLogOnCompilationShow({
    ref,
    selection,
    selectionNumber: displayedSelectionNumber,
  });

  const onSwipe = useLogCompilationSwipe(selection, displayedSelectionNumber);

  return (
    <AppsCarousel
      ref={ref}
      title={selection.title?.value || ''}
      apps={apps}
      showLinkToAll={false}
      appType={appType}
      testId="selection_with_app_list"
      onSwipe={onSwipe}
      featuringId={selection.id}
      redesignRating={redesignRating}
    />
  );
};
